// src/i18n/translations/pl.js
const translations = {
  brand: "Marka",
  category: "Kategoria",
  type: "Typ",
  cargo_capacity: "Przestrzeń bagażowa",
  seats: "Miejsca",
  created_at: "Data utworzenia",
  updated_at: "Data aktualizacji",
  id: "ID",
  user_id: "ID użytkownika",
  invoices: "Faktury",
  vehicle: "Moje pojazdy",
  transfer_all: "Przegląd wszystkich przejazdów",
  transfer_new: "Nowe przejazdy",
  transfer_assign: "Przypisz kierowcę",
  vatIdLabel: "NIP UE klienta",
  bookingAs: "Rezerwuję jako",
  privatePerson: "Osoba prywatna",
  companyOption: "Firma",
  companyName: "Nazwa firmy",
  vatIdOptional: "NIP UE (opcjonalnie)",
  vatIdInvalid: "Nieprawidłowy NIP UE (np. DE123456789)",
  receiptHint: "Do potwierdzenia/faktury",
  transfer_close: "Do zakończenia",
  completeTrip: "Zakończ",
  completeTripConfirm: "Zakończyć przejazd? Klient otrzyma e-mail z podziękowaniem i potwierdzenie; płatność zostanie oznaczona jako opłacona.",
  instantConfirmed: "Natychmiastowe potwierdzenie",
  ratingFilter: "Ocena",
  allRatings: "Wszystkie oceny",
  starsAndUp: "gwiazdek i więcej",
  instantHint: "Natychmiastowe potwierdzenie: rezerwacja jest potwierdzana od razu",
  transfer_today: "Dzisiejsze przejazdy",
  transfer_tomorrow: "Jutrzejsze przejazdy",
  transfer_current: "Trwające przejazdy",
  transfer_storno: "Anulowane przejazdy",
  transfer_reklamiert: "Zareklamowane przejazdy",
  transfer_noshow: "Niestawiennictwo",
  transfer_finished: "Zakończone przejazdy",
  transfer_all_admin: "Przegląd wszystkich przejazdów",
  transfer_new_admin: "Nowe przejazdy",
  transfer_today_admin: "Dzisiejsze przejazdy",
  transfer_tomorrow_admin: "Jutrzejsze przejazdy",
  transfer_current_admin: "Trwające przejazdy",
  transfer_storno_admin: "Anulowane przejazdy",
  transfer_reklamiert_admin: "Zareklamowane przejazdy",
  transfer_noshow_admin: "Niestawiennictwo",
  transfer_finished_admin: "Zakończone przejazdy",
  driver: "Moi kierowcy",
  first_name: "Imię",
  last_name: "Nazwisko",
  pickup_datetime: "Data / godzina odbioru",
  status: "Status",
  total_price: "Cena całkowita",
  route: "Skąd → Dokąd",
  payment_method: "Metoda płatności",
  currency: "Waluta",
  invoice_status: "Faktura",
  data: "Moja firma",
  company_active: "Użytkownik aktywowany",
  logo: "Prześlij logo firmy",
  company_name: "Nazwa firmy",
  company_legal_form: "Forma prawna",
  company_register_number: "Numer w rejestrze handlowym",
  company_street: "Adres",
  company_zip: "Kod pocztowy",
  company_country: "Kraj",
  company_city: "Miasto",
  company_tax_number: "NIP",
  company_vat_id: "Numer VAT",
  company_phone: "Numer telefonu (służbowy)",
  company_email: "Adres e-mail (służbowy)",
  company_website: "Strona internetowa",
  licence: "Prześlij licencję działalności",
  company_licence: "Czy licencja działalności jest dostępna?",
  company_licence_expiration: "Data ważności licencji działalności?",
  prices: "Ceny warstwowe",
  bis10km: "Obliczona cena za km do 10 km",
  bis20km: "Obliczona cena za km do 20 km",
  bis50km: "Obliczona cena za km do 50 km",
  bis100km: "Obliczona cena za km do 100 km",
  ab100km: "Obliczona cena za km od 100 km",
  citys: "Obsługiwane miasta",
  getpartner: "Zostań partnerem",
  partnerlogin: "Logowanie partnera",
  editbooking: "Zarządzaj rezerwacją",
  contact: "Kontakt",
  booknow: "Zarezerwuj teraz",
  oneway: "Tylko w jedną stronę",
  roundtrip: "Tam i z powrotem",
  flughafentransfer: "Transfer lotniskowy",
  ConvenientAndOnTime: "Punktualnie. Wygodnie.",
  yourTransfer: "Twój transfer.",
  bnHeadline: "Dokąd dziś jedziemy?",
  bnSub: "Transfer na lotnisko w stałej cenie – rezerwacja w kilku kliknięciach",
  bnPopular: "Popularne trasy",
  bnRoute1: "Kolonia → Lotnisko Düsseldorf",
  bnRoute2: "Essen → Lotnisko Düsseldorf",
  bnRoute3: "Düsseldorf → Lotnisko Kolonia/Bonn",
  bnRoute4: "Bonn → Lotnisko Frankfurt",
  moBestRated: "Najlepiej oceniane",
  moRecommended: "Polecane",
  moAll: "Wszystkie",
  moDetails: "Szczegóły",
  moLess: "Mniej",
  moOffersN: "{n} ofert",
  moOfferOne: "1 oferta",
  moFrom: "od",
  moPicksTitle: "Nasze propozycje dla Ciebie",
  moCheapest: "Najtańsze",
  guideHello: "Cześć, dokąd jedziemy?",
  guideTitle1: "Twój transfer",
  guideTitle2: "w 3 krokach",
  guideStepRoute: "Trasa",
  guideStepDate: "Termin",
  guideStepOffer: "Oferta",
  guideRoute: "Twoja trasa",
  guideWhen: "Kiedy?",
  guideToday: "Dziś",
  guideTomorrow: "Jutro",
  guidePick: "Data",
  guidePickupTime: "Godzina odbioru",
  guideReturn: "Dodaj przejazd powrotny",
  uberHeadline: "Twój transfer – dokądkolwiek",
  privateTransferDescription: "Prywatny transfer w stałych cenach – od drzwi do drzwi, bez niespodzianek.",
  bookRide: "Zarezerwuj przejazd",
  destination: "Miejsce docelowe",
  enterDestinationAddress: "Wpisz adres docelowy",
  returnTrip: "Przejazd powrotny",
  outboundTrip: "Przejazd w jedną stronę",
  paymentMethods: "Metody płatności",
  loading: "Ładowanie…",
  showOffers: "Pokaż oferty",
  rides: "Przejazdy",
  customerRating: "Ocena klienta",
  vehicles: "Pojazdy",
  support: "Wsparcie",
  recentSearches: "Ostatnie wyszukiwania",
  departure: "Wyjazd",
  enterStartAddress: "Wpisz adres początkowy",
  swapAddresses: "Zamień adresy",
  whyGoTransfer24: "Dlaczego GoTransfer24",
  clearBenefits: "Wyraźne korzyści",
  atAGlance: "w skrócie.",
  fairFixedPricesTitle: "Uczciwe stałe ceny",
  fairFixedPricesDescription: "Bez taksometru, bez ryzyka. Cena ustalana jest przed rezerwacją – przejrzyście i z gwarancją.",
  bookedIn60SecondsTitle: "Rezerwacja w 60 sekund",
  bookedIn60SecondsDescription: "Start, cel, pojazd – gotowe. Bez rejestracji, bez formalności, bez oczekiwania.",
  flexiblePaymentTitle: "Elastyczna płatność",
  flexiblePaymentDescription: "PayPal, karta kredytowa lub gotówka dla kierowcy. Decydujesz, co Ci odpowiada.",
  verifiedDriversTitle: "Zweryfikowani kierowcy",
  verifiedDriversDescription: "Wszyscy kierowcy są licencjonowani i osobiście zweryfikowani. Punktualność i profesjonalizm gwarantowane.",
  available247Title: "Dostępność 24/7",
  available247Description: "Wczesny lot o 4 rano? Żaden problem. Jesteśmy dla Ciebie o każdej porze dnia.",
  luggageExtrasTitle: "Bagaż i dodatki",
  luggageExtrasDescription: "Fotelik dziecięcy, dużo bagażu, zwierzę domowe – wszystko można zarezerwować. Po prostu dodaj przy kasie.",
  chooseRoute: "Wybierz trasę",
  selectTripType: "Wybierz przejazd w jedną stronę lub tam i z powrotem",
  enterAddresses: "Wpisz adres początkowy i docelowy",
  setDateTime: "Ustaw datę i godzinę",
  chooseVehicle: "Wybierz pojazd",
  compareOffersPrices: "Porównaj oferty i ceny",
  selectVehicle: "Wybierz odpowiedni pojazd",
  enterDetails: "Wprowadź dane",
  enterPassengerDetails: "Wprowadź dane pasażera",
  addFlightInformation: "Dodaj informacje o locie",
  selectExtras: "Wybierz dodatki i usługi dodatkowe",
  confirmation: "Potwierdzenie",
  selectPaymentMethod: "Wybierz metodę płatności",
  receiveBookingConfirmation: "Otrzymaj potwierdzenie rezerwacji",
  businessAirportTransfer: "Transfer lotniskowy Business",
  economyAirportTransfer: "Transfer lotniskowy Economy",
  luxuryAirportTransfer: "Transfer lotniskowy Luxury",
  vipSprinterTransfer: "Transfer VIP Sprinter",
  faqPriceQuestion: "Ile kosztuje transfer lotniskowy z GoTransfer24?",
  faqPriceAnswer: "Cena zależy od trasy, daty i wybranej klasy pojazdu i wyświetlana jest jako stała cena przed zakończeniem rezerwacji. Nie ma dodatkowych opłat za korki, jazdę nocną czy standardowy bagaż.",
  faqAdvanceBookingQuestion: "Z jakim wyprzedzeniem należy dokonać rezerwacji?",
  faqAdvanceBookingAnswer: "Rezerwacja jest możliwa nawet w krótkim terminie, jednak zalecamy co najmniej 24 godziny wcześniej – szczególnie w okresach dużego popytu, w święta lub w sezonie wzmożonych podróży.",
  faqFlightDelayQuestion: "Co się stanie, jeśli mój lot się spóźni?",
  faqFlightDelayAnswer: "Żaden problem – czas przylotu jest śledzony na żywo i automatycznie aktualizowany. Twój kierowca wie o opóźnieniu i poczeka bez dodatkowych kosztów.",
  faqCancelChangeQuestion: "Czy mogę anulować lub zmienić moją rezerwację?",
  faqCancelChangeAnswer: "Tak, zmiany i anulacje są bezpłatne do 24 godzin przed zaplanowanym odbiorem.",
  faqChildSeatsQuestion: "Czy oferujecie foteliki dziecięce i pojazdy dostępne dla wózków inwalidzkich?",
  faqChildSeatsAnswer: "Tak, podczas rezerwacji można dodać foteliki dziecięce różnych grup, a nasza klasa vanów w wielu lokalizacjach jest również dostępna dla wózków inwalidzkich.",
  faqPaymentQuestion: "Jakie metody płatności są akceptowane?",
  faqPaymentAnswer: "Online można płacić kartą, przez PayPal, Klarna, na fakturę lub w ratach. Płatność bezpośrednio kierowcy na miejscu jest również możliwa.",
  transferServiceDescription: "GoTransfer24 łączy Cię ze zweryfikowanymi kierowcami do prywatnych transferów lotniskowych w całych Niemczech i Europie. Niezależnie od tego, czy to podróż służbowa, wakacje rodzinne czy wycieczka miejska – zawozimy Cię niezawodnie i bez zbędnych postojów na lotnisko lub bezpośrednio pod drzwi. Stałe ceny, automatyczne monitorowanie lotów w przypadku opóźnień oraz rezerwacja w mniej niż minutę sprawiają, że transfer jest tak prosty, jak to możliwe.",
  routePriceCologneDusseldorf: "od 99 €",
  routePriceFrankfurtHeidelberg: "od 129 €",
  routePriceMunichAugsburg: "od 89 €",
  routePriceHamburgLuebeck: "od 79 €",
  routePriceBerlinPotsdam: "od 69 €",
  routePriceStuttgartUlm: "od 109 €",
  popularRoutes: "Popularne trasy",
  allLocations: "Wszystkie lokalizacje",
  chooseYour: "Wybierz swoje",
  airport_: "lotnisko.",
  allLocationsOverview: "Przegląd wszystkich lokalizacji",
  locationsDescription: "GoTransfer24 łączy Cię ze zweryfikowanymi partnerami-kierowcami w 26 lokalizacjach w 11 krajach. Każde miasto ma własną stronę z lokalnymi trasami, informacjami o terminalach i pytaniami specyficznymi dla danego lotniska.",
  priceDisclaimer: "* Cena, czas trwania i odległość są wartościami przybliżonymi i nie stanowią wiążącej oferty.",
  somethingWentWrong: "Coś poszło nie tak. Spróbuj ponownie.",
  sustainability: "Zrównoważony rozwój",
  everyRide: "Każdy przejazd",
  aTree: "to jedno drzewo.",
  treePlantingDescription: "Za każdą rezerwację online i przez WhatsApp sadzimy drzewo. Jako firma świadoma ekologicznie chcemy nie tylko promować zrównoważoną mobilność, ale także aktywnie przyczyniać się do ochrony środowiska. Dziękujemy za Twoje wsparcie.",
  treesPlanted: "Posadzone drzewa",
  compensated: "Skompensowane",
  howItWorks: "Jak to działa",
  inFourSteps: "W 4 krokach",
  toBooking: "do rezerwacji.",
  ourStrengths: "Nasze atuty",
  clearAdvantagesWith: "Wyraźne korzyści z",
  freeNonBindingService: "Bezpłatna, niewiążąca usługa",
  punctualPickupsGuaranteed: "Gwarantowany punktualny odbiór",
  verifiedDriverNetwork: "Zweryfikowana sieć kierowców",
  upTo70PercentCheaperThanTaxis: "Do 70% taniej niż taksówki",
  topRatingsSatisfiedCustomers: "Najwyższe oceny zadowolonych klientów",
  customerReviews: "Opinie klientów",
  whatOurCustomers: "Co mówią nasi",
  say: "klienci.",
  reviewMarco: "Bardzo punktualnie, czysty pojazd i przyjazny kierowca. Zarezerwuję ponownie.",
  reviewLena: "Łatwo zarezerwować i o wiele taniej niż taksówka. Idealne na lotnisko!",
  reviewThomas: "Profesjonalna obsługa od pierwszego kliknięcia do przyjazdu. Zdecydowanie polecam.",
  supportDescription: "W przypadku pytań, sugestii lub komentarzy nasz wykwalifikowany zespół wsparcia chętnie pomoże.",
  germany: "Niemcy",
  netherlands: "Holandia",
  belgium: "Belgia",
  france: "Francja",
  luxembourg: "Luksemburg",
  switzerland: "Szwajcaria",
  austria: "Austria",
  czechia: "Czechy",
  poland: "Polska",
  denmark: "Dania",
  turkey: "Turcja",
  cologne: "Kolonia",
  dusseldorf: "Düsseldorf",
  frankfurt: "Frankfurt",
  munich: "Monachium",
  berlin: "Berlin",
  hamburg: "Hamburg",
  stuttgart: "Stuttgart",
  hannover: "Hanower",
  amsterdam: "Amsterdam",
  eindhoven: "Eindhoven",
  brussels: "Bruksela",
  charleroi: "Charleroi",
  paris: "Paryż",
  luxembourgCity: "Luksemburg",
  zurich: "Zurych",
  geneva: "Genewa",
  basel: "Bazylea",
  vienna: "Wiedeń",
  prague: "Praga",
  warsaw: "Warszawa",
  copenhagen: "Kopenhaga",
  istanbul: "Stambuł",
  antalya: "Antalya",
  bodrum: "Bodrum",
  izmir: "Izmir",
  ankara: "Ankara",
  priceCologneDusseldorf: "od 99 €",
  priceFrankfurtHeidelberg: "od 79 €",
  priceMunichAugsburg: "od 149 €",
  priceHamburgLuebeck: "od 149 €",
  allQuestions: "Wszystkie pytania",
  viewAnswers: "Zobacz odpowiedzi",
  frequentlyAskedQuestions: "Najczęściej zadawane pytania",
  questionsAbout: "Pytania dotyczące",
  airportTransfer: "transferu lotniskowego",
  travelKnowledge: "Wiedza podróżnicza",
  guide: "Przewodnik",
  our: "Nasz",
  tipsInsightsNewsDescription: "Wskazówki, informacje i nowości dotyczące transferów lotniskowych, podróży i mobilności.",
  viewAllGuideArticles: "Zobacz wszystkie artykuły przewodnika",
  haveAQuestion: "Masz pytanie?",
  travelTips: "Wskazówki podróżnicze",
  business: "Biznes",
  family: "Rodzina",
  stressFreeAirportTransferTitle: "7 najlepszych wskazówek na bezstresowy transfer lotniskowy",
  stressFreeAirportTransferDescription: "Jak zaplanować dojazd na lotnisko tak wygodnie, jak to możliwe – od odpowiedniego zapasu czasu po właściwą klasę pojazdu.",
  businessTravelTitle: "Podróż służbowa: jak spokojnie dotrzeć na ważne spotkanie",
  businessTravelDescription: "Między lotem a terminem często zostaje niewiele czasu. Pokazujemy, jak dzięki odpowiedniemu planowaniu dotrzeć punktualnie i wypoczętym.",
  familyVacationTitle: "Wakacje rodzinne: bezpiecznie na lotnisko z dziećmi",
  familyVacationDescription: "Foteliki dziecięce, bagaż i zmęczone dzieci – dajemy praktyczne wskazówki, jak sprawić, by dojazd na lotnisko był wygodny dla całej rodziny.",
  june12_2026: "12 czerwca 2026",
  may28_2026: "28 maja 2026",
  may15_2026: "15 maja 2026",
  readTime4Minutes: "4 min czytania",
  readTime3Minutes: "3 min czytania",
  readTime5Minutes: "5 min czytania",
  roundTripShort: "Tam i z powrotem",
  editSearch: "Edytuj wyszukiwanie",
  edit: "Edytuj",
  startNewSearch: "Rozpocznij nowe wyszukiwanie",
  cancel: "Anuluj",
  search: "Szukaj",
  dateRequired: "Data jest wymagana",
  timeRequired: "Godzina jest wymagana",
  returnDateRequired: "Data powrotu jest wymagana",
  returnTimeRequired: "Godzina powrotu jest wymagana",
  vehicleCategory: "Kategoria pojazdu",
  reset: "Resetuj",
  categoryTaxi: "Taksówka",
  categoryEconomy: "Economy",
  categoryBusiness: "Business",
  categoryMinibus: "Minibus",
  categoryMinibusWheelchair: "Minibus dla wózków inwalidzkich",
  categoryGoGreen: "GoGreen",
  categoryFirstClass: "First Class",
  categoryKomfort: "Komfort",
  categoryLuxury: "Luxury",
  filterTitle: "Filtr",
  passengers: "Pasażerowie",
  vehiclesForAtLeast: "Pojazdy dla co najmniej ≥",
  people: "osób",
  luggage: "Bagaż",
  luggagePieces: "Sztuk bagażu",
  wheelchair: "Wózek inwalidzki",
  allVehicles: "Wszystkie pojazdy",
  wheelchairSeats: "Miejsca dla wózków inwalidzkich",
  noRatingsYet: "Brak ocen",
  orSimilar: "lub podobny",
  upTo: "do",
  handLuggage: "Bagaż podręczny",
  childSeatGroup1Name: "Fotelik dziecięcy, grupa 1",
  childSeatGroup1Desc: "(Ok. od 1 do 4 lat), 9–18 kg",
  childSeatGroup23Name: "Fotelik dziecięcy, grupa 2/3",
  childSeatGroup23Desc: "(Ok. od 5 do 12 lat), 18–38 kg",
  babySeatName: "Fotelik dla niemowląt",
  babySeatDesc: "Do 12 miesiąca życia. +1 kg – 9 kg",
  luggageHelpName: "Pomoc z bagażem",
  luggageHelpDesc: "Kierowca pomaga z bagażem",
  meetGreetName: "Powitanie",
  meetGreetDesc: "Kierowca wita Cię z tabliczką z imieniem i pomaga z bagażem.",
  privateRide: "Prywatny przejazd",
  support247: "Wsparcie 24/7",
  freeCancellation: "Bezpłatne anulowanie do 24h przed przejazdem",
  provider: "Dostawca",
  bookNow: "Zarezerwuj teraz",
  showLess: "Pokaż mniej",
  moreOffers: "więcej ofert",
  priceFrom: "Cena od",
  book: "Zarezerwuj",
  loadingOffers: "Ładowanie ofert …",
  noOfferIdFound: "Nie znaleziono ID oferty",
  errorLoadingOffers: "Błąd ładowania ofert",
  unknownError: "Nieznany błąd",
  offersFound: "znalezionych ofert",
  cheapest: "↑ Najtańsze",
  mostExpensive: "↓ Najdroższe",
  noVehiclesFound: "Nie znaleziono pojazdów dla wybranych filtrów.",
  resetFilters: "Resetuj filtry",
  taxi_limousine: "Taksówka Sedan",
  taxi_kombi: "Taksówka Kombi",
  taxi_van: "Taksówka Van",
  economy_limousine: "Economy Sedan",
  economy_kombi: "Economy Kombi",
  economy_minivan: "Economy Minivan",
  economy_van: "Economy Van",
  business_kombi: "Business Kombi",
  business_van: "Business Van",
  minibus: "Minibus",
  business_limousine: "Business Sedan",
  minibus_wheelchair: "Minibus dla wózków inwalidzkich",
  gogreen: "GoGreen",
  firstclass: "First Class",
  komfort: "Komfort",
  luxury: "Luxury",
  oclock: "",
  vehicleSection: "Pojazd",
  max: "Maks",
  included: "Wliczone",
  freeCancelShort: "Bezpłatne anulowanie",
  serviceProviderLabel: "Usługodawca",
  routeSection: "Trasa",
  priceOverview: "Przegląd cen",
  ride: "Przejazd",
  total: "Razem",
  loadingData: "Ładowanie …",
  noSessionIdFound: "Nie znaleziono ID sesji",
  dataLoadError: "Nie udało się załadować danych.",
  less: "mniej",
  more: "więcej",
  free: "Bezpłatnie",
  next: "Dalej",
  saving: "Zapisywanie …",
  errorSavingExtras: "Błąd podczas zapisywania usług dodatkowych.",
  extraServicesTitle: "Usługi dodatkowe",
  transferDetails: "Szczegóły transferu",
  closeDetails: "Zamknij szczegóły",
  showDetails: "Pokaż szczegóły",
  closeShort: "↓ Zamknij",
  detailsShort: "↑ Szczegóły",
  totalPrice: "Cena całkowita",
  childSeatGroup1: "Fotelik dziecięcy, grupa 1",
  childSeatGroup1Description: "(Ok. od 1 do 4 lat), 9–18 kg",
  childSeatGroup2_3: "Fotelik dziecięcy, grupa 2/3",
  childSeatGroup2_3Description: "(Ok. od 5 do 12 lat), 18–38 kg",
  infantCarrier: "Fotelik dla niemowląt",
  infantCarrierDescription: "Do 12 miesiąca życia. +1 kg – 9 kg",
  waterSnack: "Woda i przekąska",
  waterSnackDescription: "W pojeździe czeka na Państwa butelka wody i mała przekąska.",
  petTransport: "Przewóz zwierzęcia",
  petTransportDescription: "Państwa zwierzak jedzie z Państwem. Prosimy o transporter lub smycz.",
  welcomeFlowers: "Kwiaty / pakiet powitalny",
  welcomeFlowersDescription: "Bukiet lub pakiet powitalny dla gości w pojeździe – idealny dla hoteli i wesel.",
  powerBank: "Powerbank / kabel do ładowania",
  powerBankDescription: "Kabel i powerbank w pojeździe, aby telefon dotarł naładowany.",
  wifiHotspot: "Hotspot Wi-Fi",
  wifiHotspotDescription: "Pozostań online podczas jazdy dzięki hotspotowi Wi-Fi w pojeździe.",
  priorityPickup: "Odbiór priorytetowy",
  priorityPickupDescription: "Kierowca czeka przy wyjściu i pomaga z wózkiem na bagaż – najszybsza droga do pojazdu.",
  luggageAssistance: "Pomoc z bagażem",
  luggageAssistanceDescription: "Kierowca pomaga z bagażem",
  meetAndGreet: "Powitanie",
  meetAndGreetDescription: "Kierowca wita Cię z tabliczką z imieniem i pomaga z bagażem.",
  errorSavingData: "Błąd podczas zapisywania danych.",
  fillRequiredFields: "Proszę wypełnić wszystkie wymagane pola",
  fillAllRequiredFields: "Proszę wypełnić wszystkie wymagane pola",
  requiredField: "Pole wymagane",
  invalidEmail: "Nieprawidłowy adres e-mail",
  pleaseSelect: "proszę wybrać",
  title: "Tytuł",
  salutation: "Zwrot grzecznościowy",
  lastName: "Nazwisko",
  firstName: "Imię",
  mobileNumber: "Numer komórkowy",
  emailAddress: "Adres e-mail",
  zipCode: "Kod pocztowy",
  city: "Miasto",
  address: "Adres",
  houseNumber: "Nr domu",
  flightNumber: "Numer lotu",
  infoForDriver: "Informacje dla kierowcy",
  personalDataTitle: "Dane osobowe",
  personalDataDesc: "Dane dotyczące Ciebie",
  contactTitle: "Kontakt",
  contactDesc: "Podaj tutaj swoje dane kontaktowe, aby dostawca mógł się z Tobą skontaktować w razie pytań.",
  addressTitle: "Adres",
  addressDesc: "Podaj swój pełny adres, aby mógł zostać prawidłowo wskazany na fakturze.",
  outboundFlightTitle: "Dane lotu tam",
  returnFlightTitle: "Dane lotu powrotnego",
  flightDataDesc: "Podaj pełne dane lotu, abyśmy mogli optymalnie zaplanować Twój transfer.",
  mr: "Pan",
  mrs: "Pani",
  diverse: "Inne",
  reviewAndPayTitle: "Sprawdź dane i płatność",
  choosePaymentMethod: "Wybierz metodę płatności",
  comingSoon: "Wkrótce dostępne",
  cashLabel: "Płatność gotówką",
  cashDesc: "Płatność bezpośrednio dla kierowcy – rezerwacja jest potwierdzana natychmiast",
  cardOnTripLabel: "Płatność kartą dla kierowcy",
  cardOnTripDesc: "Płatność kartą na miejscu w dniu transferu",
  stripeLabel: "Karta kredytowa / debetowa",
  stripeDesc: "Visa, Mastercard, Amex, Apple Pay, Google Pay – natychmiastowe potwierdzenie",
  customOfferLabel: "Złóż ofertę",
  customOfferDesc: "Zaproponuj własną cenę – dostawca sprawdzi i potwierdzi",
  yourOfferLabel: "Twoja propozycja ceny",
  offerHint: "⏳ Musi zostać potwierdzone przez dostawcę – następnie otrzymasz link do płatności e-mailem.",
  offerInfoBanner: "Twoja propozycja ceny zostanie przekazana dostawcy. Musi on najpierw potwierdzić Twoją ofertę. Po potwierdzeniu otrzymasz indywidualny link do płatności e-mailem.",
  invoiceLabel: "Na fakturę",
  invoiceDesc: "Płatność po otrzymaniu faktury",
  installmentLabel: "Płatność ratalna",
  installmentDesc: "Płać w wygodnych ratach",
  couponTitle: "Kod kuponu",
  couponPlaceholder: "Wpisz kod …",
  redeem: "Zrealizuj",
  couponInvalid: "Ten kupon jest nieważny.",
  couponSuccess: "✓ Kupon zrealizowany!",
  bookingOverviewTitle: "Przegląd rezerwacji",
  reviewYourDataDesc: "Sprawdź swoje dane",
  contactShortDesc: "Twoje dane kontaktowe",
  emailShort: "E-mail",
  billingAddressDesc: "Adres do faktury",
  zipShort: "Kod pocztowy",
  outboundFlightDesc: "Dane lotu tam",
  returnFlightDesc: "Dane lotu powrotnego",
  checkoutLabel: "Kasa",
  sumLabel: "Suma częściowa",
  regularPrice: "Cena regularna",
  vatNote: "* z VAT",
  shareLink: "Udostępnij link",
  scanQrCode: "Zeskanuj kod QR",
  qrCodeAlt: "Kod QR tej strony",
  copyLink: "Skopiuj link",
  linkCopied: "✓ Link skopiowany!",
  agbTextBefore: "Przeczytałem/-am",
  agbLinkLabel: "Ogólne warunki",
  agbTextAfter: "i akceptuję je. *",
  newsletterOptinLabel: "Tak, chcę otrzymywać newsletter i nie przegapić żadnej oferty.",
  agbRequiredHint: "* Proszę zaakceptować warunki, aby kontynuować.",
  sendingOffer: "Wysyłanie oferty …",
  redirecting: "Przekierowywanie …",
  submitOffer: "Wyślij ofertę",
  payNow: "Zapłać teraz",
  bookingSubmitError: "Błąd podczas wysyłania rezerwacji.",
  stripeSecureNote: "Bezpieczna płatność – obsługiwana przez Stripe",
  cashNote: "Płatność gotówką bezpośrednio dla kierowcy",
  offerPendingNote: "Dostawca potwierdza i wysyła link do płatności",
  completePaymentLabel: "Zakończ płatność",
  footerCompanyDescription: "Stworzyliśmy naszą usługę, aby oferować Ci niezawodne i wysokiej jakości transfery lotniskowe zawsze i wszędzie – bez żadnych problemów.",
  footerLinksTitle: "Linki",
  aboutUs: "O nas",
  bookTransfer: "Zarezerwuj transfer",
  footerServiceTitle: "Usługi",
  vehicleFleet: "Flota pojazdów",
  faq: "FAQ",
  footerLegalTitle: "Informacje prawne",
  imprint: "Nota prawna",
  privacyPolicy: "Polityka prywatności",
  termsAndConditions: "Regulamin",
  newsletterTitle: "Newsletter",
  newsletterDescription: "Aktualne wiadomości i aktualizacje bezpośrednio na Twoją skrzynkę.",
  emailPlaceholder: "Twój adres e-mail",
  sending: "Wysyłanie…",
  subscribe: "Zapisz się",
  newsletterEmailRequired: "Proszę podać adres e-mail.",
  newsletterEmailInvalid: "Proszę podać prawidłowy adres e-mail.",
  newsletterSuccess: "Dziękujemy! Zostałeś pomyślnie zapisany.",
  newsletterError: "Zapis nie powiódł się. Spróbuj ponownie.",
  allRightsReserved: "Wszelkie prawa zastrzeżone.",
  affiliateProgram: "Program partnerski",
  affiliateHeroTitle: "Dołącz do",
  affiliateHeroAccent: "GoTransfer24.",
  affiliateHeroSub: "Polecaj nas w mediach społecznościowych, na swojej stronie internetowej lub przez swoją firmę i zarabiaj na każdym pomyślnie poleconym przejeździe.",
  becomeAffiliateCta: "Zostań partnerem",
  whyPartnerWithUs: "Dlaczego warto z nami współpracować?",
  affiliateBenefitsTitleLine1: "To otrzymujesz",
  affiliateBenefitsTitleLine2: "jako partner.",
  affiliateBenefit1: "Indywidualna prowizja od każdej poleconej rezerwacji",
  affiliateBenefit2: "Własny link śledzący dla łatwego przypisania",
  affiliateBenefit3: "Miesięczna wypłata, pełna przejrzystość",
  affiliateBenefit4: "Bez minimalnego obrotu, bez ukrytych kosztów",
  affiliateCommissionTitle: "Jak obliczana jest prowizja?",
  affiliateCommissionExplanationText: "Prowizja jest obliczana indywidualnie i zależy od zasięgu, grupy docelowej i oczekiwanej liczby poleceń. W zależności od profilu partnera zazwyczaj wynosi od 5% do 15% za każdą pomyślnie poleconą rezerwację. Po złożeniu wniosku otrzymasz osobistą ofertę z konkretną stawką.",
  affiliateCommissionDisclaimer: "Prowizja jest obliczana indywidualnie i podawana po sprawdzeniu Twojego wniosku.",
  affiliateStepsTitle: "3 kroki do zostania partnerem",
  affiliateStep1Title: "Złóż wniosek",
  affiliateStep1Desc: "Wypełnij formularz i podaj swój zasięg.",
  affiliateStep2Title: "Sprawdzenie i oferta",
  affiliateStep2Desc: "Sprawdzimy Twój profil i wyślemy Ci indywidualną stawkę.",
  affiliateStep3Title: "Polecaj i zarabiaj",
  affiliateStep3Desc: "Udostępnij swój link i otrzymuj prowizję od każdej rezerwacji.",
  affiliateFinalCtaTitle: "Gotowy, aby rosnąć razem z nami?",
  affiliateMetaTitle: "Program partnerski",
  affiliateMetaDescription: "Zostań partnerem GoTransfer24 i zarabiaj indywidualnie obliczaną prowizję od każdej poleconej rezerwacji transferu lotniskowego.",
  becomeAffiliateTitle: "Zostań partnerem",
  becomeAffiliateIntro: "Wypełnij formularz – skontaktujemy się z Tobą z indywidualną ofertą.",
  firstNameRequiredError: "Proszę podać imię",
  lastNameRequiredError: "Proszę podać nazwisko",
  emailRequiredError: "Proszę podać adres e-mail",
  emailInvalidError: "Proszę podać prawidłowy adres e-mail",
  atLeastOneOfTheFollowing: "Wypełnij co najmniej jedno z poniższych pól:",
  atLeastOneSocialRequiredError: "Proszę podać co najmniej jedno konto w mediach społecznościowych lub firmę",
  companyOptional: "Firma (opcjonalnie)",
  companyNamePlaceholder: "Nazwa firmy",
  submitApplication: "Wyślij wniosek",
  affiliateApplicationReceivedTitle: "Wniosek otrzymany!",
  affiliateApplicationReceivedText: "Dziękujemy za zainteresowanie. Sprawdzimy Twoje dane i skontaktujemy się z Tobą z indywidualną ofertą prowizji.",
  close: "Zamknij",
  successTitleOffer: "Oferta otrzymana!",
  successTitleConfirmed: "Rezerwacja potwierdzona!",
  emailFallback: "Twój adres e-mail",
  thankYouLabel: "Dziękujemy",
  offerSubtitlePart1: "! Twoja propozycja ceny",
  offerSubtitlePart2: "została przekazana dostawcy. Po sprawdzeniu otrzymasz indywidualny link do płatności na",
  cashSubtitlePart1: "! Twoja rezerwacja jest potwierdzona. Prosimy zapłacić kwotę bezpośrednio kierowcy. Potwierdzenie zostanie wysłane na",
  defaultSubtitlePart1: "! Twoja płatność została pomyślnie przetworzona. Potwierdzenie rezerwacji zostanie wysłane na",
  bookingNumberLabel: "Numer rezerwacji",
  paymentTypeLabel: "Rodzaj płatności",
  creditCardLabel: "Karta kredytowa",
  offerPaymentTypeLabel: "Oferta",
  statusLabel: "Status",
  statusPendingProviderCheck: "Oczekujące – dostawca sprawdza",
  statusConfirmed: "Potwierdzone",
  redirectingToOverviewPart1: "Za",
  secondsLabel: "sekundę",
  redirectingToOverviewPart3: "zostaniesz przekierowany do przeglądu rezerwacji …",
  redirectFailedText: "Automatyczne przekierowanie nie powiodło się.",
  goToBookingOverview: "Przejdź do przeglądu rezerwacji →",
  backToHomeLabel: "Powrót do strony głównej",
  cookieSettings: "Ustawienia plików cookie",
  logout: "Wyloguj się",
  language: "Język",
  ourtransfers: "Moje przejazdy",
  profiledescription: "Wszystkie przypisane Ci rezerwacje transferów",
  rows: "Rekordy",
  filtered: "przefiltrowano",
  searchPlaceholder: "Szukaj",
  pagingOf: "z",
  searchLabel: "Szukaj",
  resetFilter: "resetuj",
  selectedCount: "wybrano",
  clearSelection: "wyczyść",
  menuOpen: "Otwórz menu",
  menuClose: "Zamknij menu",
  flightScheduled: "Zaplanowany",
  flightActive: "W locie",
  flightLanded: "Wylądował",
  flightCancelled: "Odwołany",
  flightDiverted: "Przekierowany",
  flightIncident: "Incydent",
  flightRedirected: "Przekierowany",
  flightPrefix: "Lot",
  flightLoading: "Ładowanie danych lotu …",
  flightNotFound: "Brak danych lotu dla",
  flightCheckNote: "Proszę sprawdzić numer lotu w notatce.",
  flightDeparture: "Odlot",
  flightArrival: "Przylot",
  flightPlanned: "Zaplanowany",
  flightDelay: "Opóźnienie",
  flightDelayDep: "min odlot",
  flightDelayArr: "min przylot",
  flightBaggage: "Odbiór bagażu",
  flightBaggageBand: "Taśma",
  flightAirline: "Linia lotnicza",
  chatWithCustomer: "Czat z klientem",
  chatBooking: "Rezerwacja",
  chatLoading: "Ładowanie wiadomości …",
  chatEmpty: "Brak wiadomości. Napisz wiadomość do klienta.",
  chatInputPlaceholder: "Napisz wiadomość …",
  chatDisabled: "Czat jest wyłączony dla przeszłych/przyszłych przejazdów",
  chatOnlyToday: "Czat dostępny tylko w dniu przejazdu",
  chatClose: "Zamknij czat",
  chatOpenLabel: "Otwórz czat",
  chatButtonLabel: "Czat",
  chatLoadError: "Błąd ładowania wiadomości",
  chatSendFail: "Nie udało się wysłać wiadomości",
  chatSendError: "Błąd wysyłania wiadomości",
  salutationMr: "Pan",
  salutationMrs: "Pani",
  tripReturn: "Tam i z powrotem",
  tripOneway: "W jedną stronę",
  noTripsAvailable: "Brak dostępnych przejazdów.",
  noTripsSearch: "Brak wyników dla bieżącego wyszukiwania",
  noTrips: "Brak dostępnych przejazdów",
  pickupTag: "Odbiór",
  destinationTag: "Cel",
  paymentLabel: "Płatność",
  passengersLabel: "Pasażerowie",
  customerLabel: "Klient",
  phoneLabel: "Numer telefonu",
  extrasLabel: "Dodatki",
  noteLabel: "Notatka",
  flightInfoLabel: "Informacje o locie",
  yourSharePrefix: "Twój udział (w jedną stronę)",
  cancelBtn: "Anuluj",
  counterOfferBtn: "Kontrpropozycja",
  waitingCustomerResponse: "Oczekiwanie na odpowiedź klienta",
  newBadge: "Nowe",
  enrouteBtn: "W drodze",
  onboardBtn: "Odebrany",
  noshowBtn: "Nieobecny",
  completeBtn: "Zakończ",
  cancelledBadge: "Anulowany",
  completedBadge: "Zakończony",
  noshowDoneBadge: "Nieobecny",
  complainedBadge: "Zareklamowany",
  cancelTripTitle: "Anulować przejazd?",
  cancelBookingPrefix: "Rezerwacja",
  cancelIrreversible: "Tej czynności nie można cofnąć.",
  cancelNotifyText: "Przejazd zostanie anulowany, a klient zostanie powiadomiony.",
  fromLabel: "Skąd",
  toLabel: "Dokąd",
  dateLabel: "Data",
  abortBtn: "Anuluj",
  confirmCancelBtn: "Tak, anuluj teraz",
  tripCancelledToast: "został anulowany",
  cancelErrorToast: "Błąd podczas anulowania",
  statusEnrouteLabel: "Rozpocznij dojazd",
  statusEnrouteDesc: "Rozpoczynasz teraz dojazd do klienta.",
  statusOnboardLabel: "Pasażer odebrany",
  statusOnboardDesc: "Potwierdzasz, że odebrałeś pasażera.",
  statusCompletedLabel: "Zakończ przejazd",
  statusCompletedDesc: "Oznaczasz ten przejazd jako zakończony.",
  confirmBtn: "Potwierdź",
  statusUpdateError: "Błąd aktualizacji",
  statusEnrouteToast: "Rozpoczęto dojazd",
  statusOnboardToast: "Pasażer odebrany",
  statusCompletedToast: "Przejazd zakończony",
  counterOfferTitle: "Złóż kontrpropozycję",
  originalPriceLabel: "Cena pierwotna",
  customerOfferLabel: "Oferta klienta",
  yourCounterOfferLabel: "Twoja kontrpropozycja",
  counterOfferInvalid: "Proszę podać prawidłową kwotę.",
  counterOfferSaveError: "Błąd zapisu. Spróbuj ponownie.",
  counterOfferNotifyInfo: "Klient otrzyma powiadomienie po zapisaniu.",
  counterOfferSaving: "Zapisywanie …",
  counterOfferSendBtn: "Wyślij kontrpropozycję",
  counterOfferSavedToast: "Kontrpropozycja dla",
  counterOfferSavedToastSuffix: "zapisana",
  vehicleDialogTitle: "Wybierz pojazd",
  vehicleLoading: "Ładowanie pojazdów …",
  vehicleLoadError: "Nie udało się załadować pojazdów.",
  vehicleLoadErrorGeneric: "Błąd ładowania pojazdów.",
  vehicleNoneAvailable: "Brak dostępnych pojazdów.",
  vehicleStarting: "Uruchamianie …",
  vehicleStartBtn: "Rozpocznij dojazd",
  vehiclePleaseChoose: "Proszę wybrać pojazd",
  vehicleSaveError: "Błąd zapisu.",
  vehicleStartError: "Błąd podczas rozpoczynania dojazdu.",
  vehicleStartedToast: "Rozpoczęto dojazd",
  vehicleFallbackName: "Pojazd",
  noshowDialogTitle: "Zgłoś nieobecność",
  noshowInstructions: "Zrób zdjęcie miejsca odbioru, na którym wyraźnie widać Twój pojazd. Lokalizacja zostanie zarejestrowana automatycznie.",
  noshowMaxSizeSuffix: "Maks.",
  currentLocationLabel: "Bieżąca lokalizacja",
  locationLoading: "Ustalanie lokalizacji …",
  locationReload: "Odśwież",
  locationRetry: "Spróbuj ponownie",
  locationUnavailable: "Lokalizacja niedostępna",
  geoNotSupported: "Geolokalizacja nie jest obsługiwana przez to urządzenie.",
  geoDenied: "Nie udało się ustalić lokalizacji. Proszę zezwolić na dostęp.",
  photoOfPickupLabel: "Zdjęcie miejsca odbioru",
  photoTakeLabel: "Zrób zdjęcie",
  photoHint: "Otwórz aparat · Pojazd musi być widoczny",
  photoChange: "Zmień",
  noshowNoteLabel: "Notatka",
  noshowNoteOptional: "(opcjonalnie)",
  noshowNotePlaceholder: "np. dzwonek niedostępny, brak odpowiedzi na telefon …",
  noshowMissingPhoto: "Zrób zdjęcie miejsca odbioru.",
  noshowLocationPending: "Lokalizacja jest jeszcze ustalana. Proszę chwilę poczekać.",
  noshowPhotoTooLargePrefix: "Zdjęcie jest za duże",
  noshowPhotoTooLargeMax: "Maksymalnie",
  noshowPhotoTooLargeHint: "Zrób mniejsze zdjęcie lub zmniejsz jakość aparatu.",
  noshowPhotoTooLargeHintShort: "Zrób mniejsze zdjęcie.",
  noshowGenericSaveError: "Błąd zapisu. Spróbuj ponownie.",
  noshowSubmitError: "Błąd wysyłania. Spróbuj ponownie.",
  noshowSubmitting: "Wysyłanie …",
  noshowConfirmBtn: "Potwierdź nieobecność",
  noshowReportedToast: "Zgłoszono nieobecność dla",
  pickupLabel: "Miejsce odbioru",
  current: "Bieżące",
  trips: "Przejazdy",
  myData: "Moje dane",
  documents: "Dokumenty",
  other: "Inne",
  vehicle_class: "Moje pojazdy",
  company: "Moja firma",
  cities: "Miasta",
  wallet: "Portfel",
  receipts: "Paragony",
  terms: "Regulamin",
  privacy: "Polityka prywatności",
  new: "Nowe",
  overview: "Przegląd",
  income: "Przychody",
  expenses: "Wydatki",
  welcomeBack: "Witaj ponownie",
  dashboardErrorTitle: "Coś poszło nie tak",
  dashboardErrorText: "Nie udało się załadować danych.",
  noWidgetsTitle: "Brak skonfigurowanych widżetów",
  noWidgetsText: "Obecnie brak dostępnych kafelków przeglądu.",
  completed: "Zakończone",
  upcoming: "Nadchodzące",
  cancelled: "Anulowane",
  noShow: "Nieobecny",
  complained: "Zareklamowane",
  tomorrow: "Jutro",
  thisWeek: "W tym tygodniu",
  count: "Liczba",
  ofWhichNoShow: "W tym niestawiennictwo",
  ofWhichComplained: "W tym reklamacje",
  transfer_total: "Razem",
  transfer_done: "Zakończone",
  transfer_open: "Nadchodzące",
  transfer_week: "W tym tygodniu",
  transfer_storno_reklamiert: "W tym reklamacje",

  newTrips: "Nowe przejazdy",
  notransferdatafound: "Brak dostępnych przejazdów.",
  noResultsForFilters: "Brak wyników dla bieżących filtrów",
  returnTripOn: "Przejazd powrotny",

  generateInvoice: "Wygeneruj fakturę",
  details: "Szczegóły",
  accept: "Akceptuj",
  changeDriver: "Zmień kierowcę",
  assignDriver: "Przypisz kierowcę",
  cancelList: "Anuluj",

  counterOffer: "Kontrpropozycja",
  acceptOffer: "Zaakceptuj ofertę",
  waitingForCustomerResponse: "Oczekiwanie na odpowiedź klienta",
  waitingForCustomerPayment: "Oczekiwanie na płatność klienta",
  accepted: "Zaakceptowano",

  pleaseAssignDriver: "Proszę przypisać kierowcę",
  driverOnTheWay: "Kierowca w drodze",

  customerOnBoard: "Klient w pojeździe",

  acceptOfferQuestion: "Zaakceptować ofertę?",
  bookingPrefix: "Rezerwacja",

  confirmCustomerOffer: "Potwierdź ofertę klienta",
  customerOfferPaymentInfo: "Klient zostanie powiadomiony e-mailem i przekierowany do płatności. Po dokonaniu płatności rezerwacja zostanie automatycznie potwierdzona.",

  offerPrice: "Cena oferty",

  yesAcceptOffer: "Tak, zaakceptuj ofertę",

  selectDriver: "Wybierz kierowcę",
  loadingDrivers: "Ładowanie kierowców …",
  noDriversAvailable: "Brak dostępnych kierowców.",

  confirmTrip: "Potwierdź przejazd",
  pleaseSelectDriver: "Proszę wybrać kierowcę",

  cancelTripQuestion: "Anulować przejazd?",
  cancelNotifyCustomer: "Przejazd zostanie anulowany, a klient zostanie powiadomiony.",

  from: "Skąd",
  to: "Dokąd",

  confirmCancel: "Tak, anuluj teraz",

  create: "Utwórz",

  makeCounterOffer: "Złóż kontrpropozycję",
  originalPrice: "Cena pierwotna",
  customerOffer: "Oferta klienta",
  yourCounterOffer: "Twoja kontrpropozycja",
  counterOfferNotify: "Klient otrzyma powiadomienie po zapisaniu.",
  sendCounterOffer: "Wyślij kontrpropozycję",
  // StepDialog (Nowy rekord)
  newRecordTitle: "Utwórz nowy rekord",
  stepLabel: "Krok",
  ofLabel: "z",
  enterValuePlaceholder: "wprowadź...",
  yes: "Tak",
  no: "Nie",

  // MatchDialog
  selectMatch: "Dokonaj wyboru",

  // ConfirmDialog
  affectedRecords: "Dotknięte rekordy:",

  // FilterDialog
  applyFilterTitle: "Zastosuj filtr",
  applyFilterSubtitle: "Filtruj rekordy według kryteriów",
  active: "Aktywny",
  inactive: "Nieaktywny",
  noFilterableFields: "Brak pól do filtrowania",
  applyFilterButton: "✓ Zastosuj filtr",

  // AdminEditDialog
  editRecordTitle: "Edytuj rekord",
  bookingLabel: "Rezerwacja",
  noEditableFields: "Brak skonfigurowanych pól do edycji",
  savingEllipsis: "Zapisywanie …",
  saveButton: "✓ Zapisz",
  adminEditTooltip: "Edytuj rekord (Administrator)",

  // Footer / Paging
  filteredLabel: "(przefiltrowano)",
  recordsLabel: "Rekordy",
  filterLabel: "Filtr:",
  selectedLabel: "wybrano",
  clearLabel: "wyczyść",

  // Trip-Type Fallbacks
  tripTypeReturn: "Tam i z powrotem",
  tripTypeOneway: "W jedną stronę",

  // Formatting
  driverFallbackPrefix: "Kierowca #",

  // Toasts
  toastOfferAccepted: "Oferta dla #{id} zaakceptowana – klient zostanie powiadomiony",
  toastInvoiceCreated: "Faktura dla #{id} została utworzona",
  toastDriverChanged: "Zmieniono kierowcę",
  toastDriverConfirmed: "potwierdzony",
  toastTripUpdated: "Przejazd #{id} został zaktualizowany ({label})",
  toastTripCancelled: "Przejazd #{id} został anulowany",
  toastCounterOfferSaved: "Kontrpropozycja dla #{id} zapisana",
  toastRecordUpdated: "Rekord #{id} został zaktualizowany",

  // Error Messages
  errorAcceptOffer: "Błąd podczas akceptowania oferty",
  errorCreateInvoice: "Błąd podczas tworzenia faktury",
  errorSaveTrip: "Błąd podczas zapisywania przejazdu.",
  errorChangeDriver: "Błąd podczas zmiany kierowcy.",
  errorConfirmTrip: "Błąd podczas potwierdzania przejazdu.",
  errorCancelTrip: "Błąd podczas anulowania",
  errorInvalidAmount: "Proszę podać prawidłową kwotę.",
  errorSaveRetry: "Błąd zapisu. Spróbuj ponownie.",
  errorLoadDriversFailed: "Nie udało się załadować kierowców.",
  errorLoadDrivers: "Błąd ładowania kierowców.",
  errorSaveDefault: "Błąd zapisu",
  discount: "Rabat",
  couponAvailableNote: "Zdobądź swój kupon rabatowy już teraz!",
  copied: "Skopiowano!",
  clickToCopy: "Kliknij, aby skopiować",
  appDownloadBannerText: "Aplikacja GoTransfer24",
  appDownloadBannerCta: "Pobierz",
  planned: "Zaplanowane",
  aktive_stat: "Aktywne",
  done: "Zakończone",
  en_route: "Kierowca w drodze",
  onboard: "Klient w pojeździe",
  card: "Płatność kartą",
  cash: "Płatność gotówką",
  cardOnTrip: "Płatność kartą dla kierowcy",
  cardontrip: "Płatność kartą dla kierowcy",
  thisweek: "W tym tygodniu",
  unpaid: "Płatność oczekująca",
  paid: "Opłacone",
  paypalLabel: "PayPal",
  paypalDesc: "Płać bezpiecznie za pomocą konta PayPal",
  paypalSecureNote: "Zostaniesz bezpiecznie przekierowany do PayPal",
  redirectingPaypal: "Przekierowywanie do PayPal …",
  paypalCancelledNote: "Płatność PayPal została anulowana.",
  paypalFailedNote: "Nie udało się zrealizować płatności PayPal.",
  paypal: "paypal",
  actual: "Bieżące",
  transfers: "Przejazdy",
  mydata: "Moje dane",
  others: "Inne",
  vehicleclass: "Moje pojazdy",
  impressum: "Nota prawna",
  agb: "Regulamin",
  datenschutz: "Polityka prywatności",
  booking: "Rezerwacja",
  transferTripLabel: "Przejazd transferowy",
  outboundReturnTrip: "Tam i z powrotem",
  onewayTrip: "W jedną stronę",
  departureLabel: "Wyjazd",
  distanceLabel: "Odległość",
  returnTripSection: "Przejazd powrotny",
  customerSection: "Klient",
  baggageLabel: "Bagaż",
  emergencyContactLabel: "Kontakt awaryjny",
  paymentSection: "Płatność",
  basePriceLabel: "Cena bazowa",
  offerPriceLabel: "Cena oferty",
  counterOfferLabel: "Kontrpropozycja",
  categoryLabel: "Kategoria",
  paymentMethodLabel: "Metoda płatności",
  pricePerKmLabel: "Cena/km",
  receiptLabel: "Paragon",
  createdLabel: "Utworzono",
  notCreatedYetLabel: "Jeszcze nie utworzono",
  noCounterOfferYet: "Nie złożono jeszcze kontrpropozycji",
  priceAccepted: "Cena zaakceptowana",
  noShowReportSection: "Zgłoszenie nieobecności",
  reportedAtLabel: "Zgłoszono o",
  accuracyLabel: "Dokładność",
  locationLabel: "Lokalizacja",
  openInGoogleMaps: "Otwórz w Google Maps",
  driverNoteLabel: "Notatka kierowcy",
  driverNoticeLabel: "Uwaga kierowcy",
  driverPhotoLabel: "Zdjęcie od kierowcy",
  noShowPhotoAlt: "Zdjęcie dowodowe nieobecności",
  extrasSection: "Dodatki / Usługi dodatkowe",
  totalExtrasLabel: "Suma dodatków",
  notesSection: "Uwagi",
  customerNoteLabel: "Notatka klienta",
  shortNoteLabel: "Krótka notatka",
  internalNoteLabel: "Notatka wewnętrzna",
  ratingSection: "Ocena",
  bookingDetailsSection: "Szczegóły rezerwacji",
  createdAtLabel: "Data utworzenia",
  updatedAtLabel: "Zaktualizowano",
  bookingSourceLabel: "Źródło rezerwacji",
  tripTypeLabel: "Rodzaj przejazdu",
  externalIdLabel: "Zewnętrzny ID",
  canceledAtLabel: "Anulowano o",
  cancelReasonLabel: "Powód anulowania:",
  paymentPendingLabel: "Płatność oczekująca",
  paidLabel: "Opłacone",
  paymentFailedLabel: "Nieudana",
  sourceWebsite: "Strona internetowa",
  sourceManual: "Ręcznie",
  sourceApi: "API",
  // Polski (pl.js)
  pleaseSelectImageFile: "Proszę wybrać plik obrazu.",
  fileTooLargeError: "Plik jest za duży (maks. 10 MB).",
  driverCreatedToast: "Kierowca został utworzony",
  driverCreateErrorFallback: "Błąd podczas tworzenia kierowcy",
  deleteDriverTitle: "Usuń kierowcę",
  deleteDriverConfirmPrefix: "Czy na pewno chcesz usunąć",
  deleteDriverConfirmSuffix: "? Tej czynności nie można cofnąć.",
  driverDeletedToast: "Kierowca został usunięty",
  deleteErrorToast: "Błąd podczas usuwania",
  wasDeactivated: "został dezaktywowany",
  wasActivated: "został aktywowany",
  statusUpdateErrorToast: "Błąd podczas aktualizacji statusu",
  licenseExpired: "Wygasło",
  licenseExpiresIn: "Wygasa za",
  daysAbbrev: "dni",
  licenseValidUntil: "Ważne do",
  activeLabel: "Aktywny",
  inactiveLabel: "Nieaktywny",
  detailsButton: "Szczegóły",
  deactivateButton: "Dezaktywuj",
  activateButton: "Aktywuj",
  deleteButton: "Usuń",
  createDriverTitle: "Dodaj nowego kierowcę",
  yesLabel: "Tak",
  noLabel: "Nie",
  enterPlaceholderSuffix: "wprowadź…",
  enterPlaceholderSuffixNoDots: "wprowadź...",
  profilePhotoLabel: "Zdjęcie profilowe",
  optionalLabel: "opcjonalnie",
  previewAlt: "Podgląd",
  changePhotoLabel: "Zmień zdjęcie",
  uploadPhotoLabel: "Prześlij zdjęcie",
  removePhotoLabel: "Usuń zdjęcie",
  photoOptionalHint: "Nie jest wymagane – zdjęcie można dodać później w profilu.",
  cancelButton: "Anuluj",
  creatingLabel: "Tworzenie…",
  createButton: "Utwórz",
  enabledLabel: "Włączone",
  disabledLabel: "Wyłączone",
  filterDriversDesc: "Filtruj kierowców według kryteriów",
  resetButton: "Resetuj",
  filterButton: "Filtr",
  newDriverButton: "Nowy kierowca",
  ofLabelLower: "z",
  driversLabel: "Kierowcy",
  searchColonLabel: "Szukaj:",
  resetLowerButton: "resetuj",
  filterColonLabel: "Filtr:",
  clearLowerButton: "wyczyść",
  loadingAriaLabel: "Ładowanie…",
  // Polski (pl.js)
  driverSavedToast: "Kierowca został zapisany",
  saveErrorToast: "Błąd zapisu",
  imageProcessingError: "Błąd podczas przetwarzania obrazu.",
  savingLabel: "Zapisywanie…",
  photoCardTitle: "Zdjęcie",
  photoSizeHint: "JPG/PNG, maks. 10 MB · zostanie zmniejszone do 300×600 px",
  dataCardTitle: "Dane",
  // Polski (pl.js)
  licensePlateHint: "Format: 1–3 litery, 1–2 litery, 1–4 cyfry – np. M AB 1234",
  pricesLoadError: "Nie udało się załadować cen.",
  vehiclesLoadError: "Nie udało się załadować pojazdów.",
  pleaseSelectBrandError: "Proszę wybrać lub wpisać markę",
  pleaseSelectModelError: "Proszę wybrać lub wpisać model",
  pleaseSelectColorError: "Proszę wybrać lub wpisać kolor",
  pleaseEnterLicensePlateError: "Proszę wpisać numer rejestracyjny",
  invalidFormatPrefix: "Nieprawidłowy format –",
  vehicleAddedToast: "Pojazd został dodany",
  vehicleAddErrorToast: "Błąd podczas dodawania pojazdu",
  vehicleDeletedToast: "Pojazd został usunięty",
  vehicleDeleteErrorToast: "Błąd podczas usuwania pojazdu",
  vehicleActivatedToast: "Pojazd aktywowany",
  vehicleDeactivatedToast: "Pojazd dezaktywowany",
  statusChangeErrorToast: "Błąd podczas zmiany statusu",
  pleaseSFillValidPricePrefix: "Proszę wypełnić",
  pleaseSFillValidPriceSuffix: "prawidłową ceną",
  pricesSavedToast: "Ceny zostały zapisane",
  pricesSaveErrorToast: "Błąd podczas zapisywania cen",
  vehicleCategoriesTitle: "Kategorie pojazdów",
  vehicleCategoriesDesc: "Zarządzaj cenami warstwowymi i pojazdami bezpośrednio według kategorii.",
  vehiclesInThisClass: "Pojazdy w tej klasie",
  pricesSectionLabel: "Ceny",
  tiersLabel: "Poziomy",
  pricePerKmShort: "€ / km",
  minPriceLabel: "Cena minimalna",
  savePricesButton: "Zapisz ceny",
  vehiclesSectionLabel: "Pojazdy",
  loadingVehiclesLabel: "Ładowanie pojazdów…",
  noVehiclesInClassLabel: "Brak pojazdów w tej klasie",
  brandLabel: "Marka",
  modelLabel: "Model",
  colorLabel: "Kolor",
  licensePlateLabel: "Numer rejestracyjny",
  addVehicleTitle: "Dodaj pojazd",
  selectBrandOption: "Wybierz markę…",
  otherOption: "Inne…",
  enterBrandPlaceholder: "Wpisz markę",
  selectModelOption: "Wybierz model…",
  selectBrandFirstOption: "Najpierw wybierz markę",
  enterModelPlaceholder: "Wpisz model",
  selectColorOption: "Wybierz kolor…",
  enterColorPlaceholder: "Wpisz kolor",
  licensePlateExamplePlaceholder: "np. M AB 1234",
  addVehicleButton: "Dodaj pojazd",
  deleteVehicleModalTitle: "Usunąć pojazd?",
  thisVehicleLabel: "Ten pojazd",
  willBeRemovedFromCategoryPrefix: "zostanie trwale usunięty z kategorii",
  willBeRemovedFromCategorySuffix: ".",
  deletingLabel: "Usuwanie…",
  // Polski (pl.js)
  fileTooLargeMaxAlert: "Plik jest za duży. Maksimum: 10MB",
  addressInputPlaceholder: "Wpisz adres i wybierz z listy...",
  previewSuffix: "Podgląd",
  uploadSuffix: "prześlij",
  removeButton: "Usuń",
  photoUploadRecommendationHint: "Zalecane: JPG/PNG, maks. 10MB, zostanie automatycznie zmniejszone do 300x600px",
  addressRequiredFieldError: "Pole wymagane – proszę wybrać adres z listy",
  noFieldGroupsDefined: "Nie zdefiniowano grup pól",
  fillAllRequiredAddressFieldsError: "Proszę wypełnić wszystkie wymagane pola – dla pól adresu wybierz sugestię z listy.",
  readonlyLabel: "tylko do odczytu",
  // Polski (pl.js)
  selectAtLeastOneRecordError: "Proszę wybrać co najmniej jeden rekord.",
  selectOnlyOneRecordToEditError: "Proszę wybrać tylko jeden rekord do edycji.",
  noRecordsSelectedError: "Nie wybrano żadnych rekordów.",
  actionExecutedSuccessSuffix: "wykonano pomyślnie",
  noDataAvailableLabel: "Brak dostępnych danych.",
  noRecordsAvailableLabel: "Brak dostępnych rekordów",
  createNewRecordTitle: "Utwórz nowy rekord",
  makeSelectionTitle: "Dokonaj wyboru",
  affectedRecordsLabel: "Dotknięte rekordy:",
  idsLabel: "ID",
  filterRecordsDesc: "Filtruj rekordy według kryteriów",
  deselectAllLabel: "Odznacz wszystko",
  selectAllLabel: "Zaznacz wszystko",
  clearSelectionLabel: "Wyczyść zaznaczenie",
  sortedByLabel: "Posortowano",
  filtersActiveLabel: "Aktywne filtry",
  // Polski (pl.js)
  addButtonLabel: "Dodaj",
  // Polski (pl.js)
  periodAllLabel: "Wszystko",
  periodTodayLabel: "Dzisiaj",
  periodWeekLabel: "Tydzień",
  periodMonthLabel: "Miesiąc",
  periodYearLabel: "Rok",
  transferLabel: "Przelew",
  cashShortLabel: "Gotówka",
  cardShortLabel: "Karta",
  canceledLabel: "Anulowane",
  balanceLoadError: "Nie udało się załadować salda.",
  noWalletDataFound: "Nie znaleziono danych portfela.",
  partnerAccountLabel: "Konto partnera",
  walletTitle: "Portfel",
  currentBalanceLabel: "Bieżące saldo",
  noPayableBalanceTitle: "Brak salda do wypłaty",
  payoutButton: "Wypłać",
  transactionsLabel: "Transakcje",
  searchBookingNumberPlaceholder: "Szukaj numeru rezerwacji",
  noResultsForPrefix: "Brak wyników dla",
  noTransactionsInPeriod: "Brak transakcji w tym okresie.",
  closeAriaLabel: "Zamknij",
  payoutRequestedTitle: "Wypłata zażądana",
  willBeTransferredSoonText: "zostaną wkrótce przelane na powiązane konto.",
  closeButton: "Zamknij",
  confirmPayoutTitle: "Potwierdź wypłatę",
  amountTransferredToAccountText: "Kwota zostanie przelana na następujące konto:",
  accountHolderLabel: "Posiadacz konta",
  ibanLabel: "IBAN",
  bankLabel: "Bank",
  payoutAmountLabel: "Kwota wypłaty",
  payoutTriggerErrorText: "Nie udało się zainicjować wypłaty. Spróbuj ponownie.",
  requestingPayoutLabel: "Żądanie…",
  payoutNowButton: "Wypłać teraz",
  passengerCountTitle: "Liczba pasażerów",
  // Polnisch
paymentCreditCardTitle: "Karta kredytowa",
paymentCreditCardDescription: "Bezpieczna płatność online od razu przy rezerwacji.",
paymentPaypalTitle: "PayPal",
paymentPaypalDescription: "Wygodna płatność przez konto PayPal – możliwość zapłaty później lub w ratach.",
paymentCashTitle: "Płatność gotówką",
paymentCashDescription: "Zapłać stałą cenę gotówką bezpośrednio kierowcy.",
paymentCardOnTripTitle: "Karta u kierowcy",
paymentCardOnTripDescription: "Płatność zbliżeniowa kartą bezpośrednio w pojeździe.",
paymentCustomOfferTitle: "Własna propozycja ceny",
paymentCustomOfferDescription: "Zaproponuj własną cenę, nasz partner ją potwierdzi.",
paymentTagInstant: "Natychmiastowe potwierdzenie",
paymentTagSSL: "Szyfrowanie SSL",
paymentTagInstallments: "Płatność ratalna",
paymentTagPayLater: "Zapłać później",
paymentTagNoPrepay: "Bez przedpłaty",
paymentTagContactless: "Zbliżeniowo",
paymentTagNegotiable: "Do negocjacji",
payHowItSuitsYou: "Płać tak,",
payHowItSuitsYouAccent: "jak Ci wygodnie.",
// Polnisch
roundTripSavingsNotice: "Oszczędzasz {percent}% przy rezerwacji przejazdu tam i z powrotem.",
removeReturnTrip: "Usuń podróż powrotną",
selectDate: "Wybierz datę",
clockSuffix: "",
back: "Wstecz",
date: "Data",
time: "Godzina",
apply: "Zastosuj",
pleaseChoose: "Proszę wybrać",
cityAirport: "Miasto / Lotnisko",
addReturnTrip: "Dodaj podróż powrotną",
closeForm: "Zamknij formularz",
transferMode: "Transfer",
flightsMode: "Loty",
slide: "Slajd",
hotline: "Infolinia",
email: "E-mail",
enterStartAddressError: "Podaj adres wyjazdu",
selectAddressFromListError: "Wybierz adres z listy",
enterDestinationAddressError: "Podaj adres docelowy",
dateRequiredError: "Data jest wymagana",
timeRequiredError: "Godzina jest wymagana",
departureTimeMinOneHourError: "Godzina wyjazdu musi być co najmniej 1 godzinę w przyszłości",
returnDateRequiredError: "Data powrotu jest wymagana",
returnTimeRequiredError: "Godzina powrotu jest wymagana",
returnTimeMinOneHourError: "Godzina powrotu musi być co najmniej 1 godzinę w przyszłości",
services: "Usługi dodatkowe",
  waitingTime: "Czas oczekiwania",
  waitingTimeDescription: "Kierowca poczeka na Ciebie dłużej – do zamówienia w odstępach 15 minut.",
  pickupAdjust: "Dostosowanie godziny odbioru przy opóźnieniu lotu",
  pickupAdjustDescription: "Jeśli Twój lot się opóźni, automatycznie przesuniemy godzinę odbioru – kierowca na Ciebie poczeka.",
  waitingFreeIncluded: "{min} min bezpłatnie w cenie",
  waitingEachExtra: "każde kolejne {min} min {price} €",
  flightRequiredForAdjust: "Dla zamówionego dostosowania godziny odbioru podaj numer lotu (np. LH123).",
  sessionExpiredTitle: "Sesja wygasła",
  sessionExpiredText: "Ze względów bezpieczeństwa zostałeś wylogowany. Zaloguj się ponownie – Twoje dane nie zostały utracone.",
  sessionExpiredButton: "Do logowania",
  flightHintTitle: "Czy godzina odbioru pasuje do lądowania?",
  flightHintText: "Twój lot {flight} ma wylądować około {landing} – wybrana godzina odbioru ({pickup}) jest wcześniejsza. Wybierz godzinę odbioru po lądowaniu:",
  flightHintKeep: "Zostaw godzinę odbioru {pickup}",
  flightHintChanged: "Godzina odbioru została zmieniona na {time}.",
  flightHintReturnPrefix: "Powrót",
  tabCancelled: "Anulowane"
};

export default translations;
